import { CallMethods } from '@app/constants';
import { apiCall } from '@app/helpers/apiCall';
import { apiEndpoints, AppThunk } from '@westondev/tableturn-core';
import { setShowToast } from '../app/actions';
import { t } from 'i18next';

export const acceptInvite = (
  userId: number,
  orgId: number,
  onContinue: () => void,
): AppThunk<Promise<boolean>> => {
  return async dispatch => {
    try {
      await apiCall(
        CallMethods.GET,
        apiEndpoints.user.acceptInviteFromWebPortal(userId, orgId),
        true,
      );
      onContinue();
      return true;
    } catch (error) {
      dispatch(
        setShowToast({
          type: 'error',
          title: t('loggedIn.myOrganizations.acceptInviteFailureToast.title'),
          description: t(
            'loggedIn.myOrganizations.acceptInviteFailureToast.description',
          ),
        }),
      );
      return false;
    }
  };
};
